import * as React from 'react';
import { withTheme } from 'styled-components';
import { Component } from 'react';
import { ShareclassColumn } from './ShareclassRows';
import { observer } from 'mobx-react';
import Icon from './Icon';

@observer
class ShareclassRowExpander extends Component<any, any> {
    render() {
        const { theme, rowExpanderConfig, shareClass } = this.props;
        const fileName = shareClass.expanded
            ? (rowExpanderConfig && rowExpanderConfig.collapseIconFileName) ||
              'CollapseIcon'
            : (rowExpanderConfig && rowExpanderConfig.expandIconFileName) ||
              'ExpandIcon';

        return (
            <ShareclassColumn
                paddingX="0"
                width="40px"
                textAlign="center"
                {...theme.ShareclassColumnExpand}
            >
                <Icon
                    iconSize="1.4em"
                    fileName={fileName}
                    {...theme.ShareclassColumnExpandIcon}
                    accessibilityContext={`for share class identified by ${shareClass.shareClass.clientCode}`}
                />
            </ShareclassColumn>
        );
    }
}

export default withTheme(ShareclassRowExpander) as any;



// WEBPACK FOOTER //
// ./src/Components/ShareclassRowExpander.tsx